import apiCall from "../utils/apiCall";

export default class RolesService {
    static listRoles = async () => {
        return await apiCall(`/api/Roles`, "GET", null, null, null, true);
    }
}